import type { StateCreator } from 'zustand/vanilla';
import type { COST_TYPE, CreditCostInfo, CreditCostMap, ProjectDetailType, ViewResourceItem } from '@/app/types';
import { getCostMapKey } from '@/app/utils';

/**
 * Store 状态类型
 */
interface AgentProjectStoreState {
  /** 项目详情 */
  agentProjectDetail: ProjectDetailType | null;
  /** 当前项目是否是只读项目 */
  agentReadOnly: boolean;

  // 资源查看列表
  agentIsOpenViewResourceDialog: boolean;
  agentViewResourceList: ViewResourceItem[] | null;
  agentPropsActiveItemId: string | null;

  agentCreditCostMap: CreditCostMap;
}

/**
 * Store Actions 类型
 */
export interface AgentProjectStore extends AgentProjectStoreState {
  /** 设置项目详情 */
  setAgentProjectDetail: (project: ProjectDetailType | null) => void;
  /** 设置当前项目是否是只读项目 */
  setAgentReadOnly: (readOnly: boolean) => void;

  // openViewResourceDialog
  openAgentViewResourceDialog: (list: ViewResourceItem[], propsActiveItemId?: string) => void;
  updateAgentViewResourceList: (list: ViewResourceItem[]) => void;
  closeAgentViewResourceDialog: () => void;

  // creditCostMap
  setAgentCreditCostMap: (creditCostMap: CreditCostMap) => void;

  getAgentCreditCost: (costType: COST_TYPE, duration: number) => CreditCostInfo | undefined;

  /** 关闭agent项目 */
  closeAgentProject: () => void;
}

/**
 * 初始状态
 */
const initialState: AgentProjectStoreState = {
  agentProjectDetail: null,
  agentReadOnly: false,
  agentIsOpenViewResourceDialog: false,
  agentViewResourceList: null,
  agentPropsActiveItemId: null,
  agentCreditCostMap: new Map(),
};

export const createAgentProjectSlice: StateCreator<AgentProjectStore, [], [], AgentProjectStore> = (set, get) => ({
  ...initialState,

  setAgentProjectDetail: (project: ProjectDetailType | null) => {
    if (!project) {
      set({ agentProjectDetail: null });
      return;
    }
    set({ agentProjectDetail: { ...project } });
  },

  setAgentReadOnly: (readOnly: boolean) => {
    set({ agentReadOnly: readOnly });
  },

  openAgentViewResourceDialog: (list: ViewResourceItem[], propsActiveItemId?: string) => {
    list.length &&
      set({
        agentIsOpenViewResourceDialog: true,
        agentViewResourceList: list,
        agentPropsActiveItemId: propsActiveItemId || list[0].id,
      });
  },

  updateAgentViewResourceList: (list: ViewResourceItem[]) => {
    set({ agentViewResourceList: list });
  },

  closeAgentViewResourceDialog: () => {
    set({
      agentIsOpenViewResourceDialog: false,
      agentViewResourceList: null,
      agentPropsActiveItemId: null,
    });
  },

  setAgentCreditCostMap: (creditCostMap: CreditCostMap) => {
    set({ agentCreditCostMap: creditCostMap });
  },
  getAgentCreditCost: (costType: COST_TYPE, duration: number) => {
    return get().agentCreditCostMap.get(getCostMapKey(costType, duration));
  },

  closeAgentProject: () => {
    set({ ...initialState });
  },
});
